// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"n3-z","colorTextValue":"o3-z","swatches":"p3-z","collapseLink":"q3-z","isCollapsed":"r3-z","dropdown":"s3-z","disabled":"t3-z"};